module.exports = __webpack_public_path__ + "static/media/illustration-section-07.8d7c1e35.svg";